import {TRegisterFormData} from './types'

export const month = [
	'Th01',
	'Th02',
	'Th03',
	'Th04',
	'Th05',
	'Th06',
	'Th07',
	'Th08',
	'Th09',
	'Th10',
	'Th11',
	'Th12'
]
export const monthEN = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Sep'
]

export const COMPANY_IMAGE_DEFAULT = `${process.env.BASE_IMAGES_URL}/img/company-default-logo.svg`

export const INITIAL_REGISTER_FORM_DATA: TRegisterFormData = {
	fullName: '',
	email: '',
	phone: '',
	jobLevelId: 0,
	highestdegreeId: 0,
	cityId: 0,
	industryId: 0,
	eventId: 0
}
